/**
 * Cart gate + date rules
 * - Blocks checkout & express wallets until required fields are valid
 * - Applies pickup/shipping lead-time rules from section settings
 */
(function () {
  if (!/\/cart(?:\?|$)/.test(location.pathname)) return;

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const isVisible = el => !!(el && el.offsetParent !== null);
  const isRequiredAndVisible = el =>
    el.hasAttribute('required') && !el.disabled && isVisible(el);

  /* ------------ DATE RULES (from bottom sliders) ------------ */

  function getDateConfig() {
    const node = $('#cf-date-config');
    if (!node) return { pickup: 0, shipping: 0 };

    const pickup   = parseInt(node.dataset.pickupMin || '0', 10) || 0;
    const shipping = parseInt(node.dataset.shippingMin || '0', 10) || 0;
    return { pickup, shipping };
  }

  function datePlusDays(days) {
    const d = new Date();
    d.setDate(d.getDate() + (days || 0));
    // yyyy-mm-dd
    return d.toISOString().slice(0, 10);
  }

  function applyDateRuleToLine(line) {
    if (!line) return;

    const cfg = getDateConfig();
    const methodEl = line.querySelector('[data-field="delivery_method"]');
    const dateEl   = line.querySelector('input[type="date"][data-field="date_needed"]');

    if (!dateEl) return;

    const methodVal = (methodEl?.value || '').toLowerCase();
    let days;

    if (methodVal.includes('pick')) {
      days = cfg.pickup;
    } else if (methodVal.includes('ship')) {
      days = cfg.shipping;
    } else {
      // fallback: use the larger of the two
      days = Math.max(cfg.pickup, cfg.shipping);
    }

    const min = datePlusDays(days);

    dateEl.min = min;
    if (dateEl.value && dateEl.value < min) {
      dateEl.value = min;
    }
  }

  function applyDateRulesAllLines() {
    $$('[data-line][data-can-customize="true"]').forEach(applyDateRuleToLine);
  }

  /* ---------------- Gate banner helper ---------------- */

  function setGateBanner(msg) {
    let b = $('#cf-checkout-warning');
    if (!msg) { if (b) b.remove(); return; }
    if (!b) {
      const after = $("button[name='checkout'], [data-checkout-button]");
      b = document.createElement('div');
      b.id = 'cf-checkout-warning';
      b.className = 'cf-gate-banner';
      if (after && after.parentNode) after.parentNode.insertBefore(b, after.nextSibling);
      else document.body.appendChild(b);
    }
    b.textContent = msg;
  }

  /* ---------------- Validation for required fields ---------------- */

  function validateAll() {
    const invalid = [];

    $$('[data-line][data-can-customize="true"]').forEach(line => {
      $$('.cf-accordion details.tgx-cust', line).forEach(group => {
        const reqs = $$('[required]', group).filter(isRequiredAndVisible);

        reqs.forEach(el => {
          let ok = true;

          if (el.type === 'radio') {
            const n = el.name;
            const radios = $$(`input[type="radio"][name="${CSS.escape(n)}"]`, group);
            ok = radios.some(r => r.checked);

          } else if (el.tagName === 'SELECT') {
            const idx = el.selectedIndex;
            const val = idx > 0 ? (el.options[idx]?.value ?? '') : '';
            ok = val.trim() !== '';

          } else {
            ok = ((el.value || '').trim() !== '');
          }

          el.classList.toggle('cf-missing', !ok);
          if (!ok) invalid.push({ el, group, line });
        });
      });
    });

    return { ok: invalid.length === 0, invalid };
  }

  /* ---------------- Wallet overlay guard ---------------- */

  function guardWallets(valid) {
    const boxes = [
      '.additional-checkout-buttons',
      '.shopify-payment-button',
      '.shopify-cleanslate'
    ].map(s => $(s)).filter(Boolean);

    boxes.forEach(box => {
      box.classList.add('cf-wallet-box');
      let guard = box.querySelector('#cf-wallet-guard');
      if (!guard) {
        guard = document.createElement('div');
        guard.id = 'cf-wallet-guard';
        guard.style.cssText =
          'position:absolute;inset:0;border-radius:inherit;background:transparent;pointer-events:auto;z-index:9999;cursor:not-allowed;display:none;';
        box.appendChild(guard);
      }
      guard.style.display = valid ? 'none' : 'block';
    });
  }

  /* ---------------- Reliable checkout submit ---------------- */

  function submitCheckout() {
    const form =
      $("form[action*='/cart']") ||
      document.querySelector('form.cart') ||
      document.querySelector("form[action='/cart']");

    if (!form) { location.assign('/checkout'); return; }

    if (!form.querySelector("input[name='checkout']")) {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = 'Checkout';
      form.appendChild(hidden);
    }

    form.method = 'post';
    form.action = '/cart';
    form.submit();
  }

  /* ---------------- Main checkout click ---------------- */

  function onCheckoutClick(e) {
    const btn = e.target.closest("button[name='checkout'], [data-checkout-button]");
    if (!btn) return;

    // always make sure date rules are applied before validating
    applyDateRulesAllLines();

    const { ok, invalid } = validateAll();
    guardWallets(ok);

    if (ok) {
      e.preventDefault();
      setGateBanner('');
      submitCheckout();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    const first = invalid[0];
    if (first?.group && !first.group.open) first.group.open = true;
    if (first?.el) {
      first.el.focus({ preventScroll: true });
      first.el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    setGateBanner('Please complete the required details for each customizable item before checkout.');
  }

  /* ---------------- Express wallet click ---------------- */

  function onWalletClick(e) {
    if (!e.target.closest('.additional-checkout-buttons, .shopify-payment-button, .shopify-cleanslate')) return;

    applyDateRulesAllLines();

    const { ok, invalid } = validateAll();
    guardWallets(ok);

    if (ok) { setGateBanner(''); return; }

    e.preventDefault();
    e.stopImmediatePropagation();

    const first = invalid[0];
    if (first?.group && !first.group.open) first.group.open = true;
    first?.el?.focus?.({ preventScroll: true });
    first?.el?.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
    setGateBanner('Please complete the required details for each customizable item before checkout.');
  }

  /* ---------------- Live re-checks + date rule updates ---------------- */

  function recheck() {
    applyDateRulesAllLines();
    const { ok } = validateAll();
    guardWallets(ok);
    if (ok) setGateBanner('');
  }

  // if Delivery Method changes in a line, re-apply its date min
  document.addEventListener('change', (e) => {
    const dm = e.target.closest('[data-field="delivery_method"]');
    if (dm) {
      const line = dm.closest('[data-line]');
      applyDateRuleToLine(line);
    }
  }, true);

  // global listeners (capture so we can block when needed)
  document.addEventListener('click',  onCheckoutClick, true);
  document.addEventListener('click',  onWalletClick,  true);
  document.addEventListener('input', recheck,        true);
  document.addEventListener('change',recheck,        true);

  // initial pass on load
  applyDateRulesAllLines();
  guardWallets(validateAll().ok);

})();
